import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Popconfirm, Tooltip } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { useStoreState } from "easy-peasy";

export default function DeleteParameterButton({
  onDelete,
  onRestore,
  disabled,
  loading,
  record,
  authSubject,
  mode = "delete",
  ...props
}) {
  const { abilities } = useStoreState((store) => store.auth);

  return mode === "restore" ? (
    <Tooltip title="Geri Al" placement="bottom">
      <Button
        onClick={onRestore}
        disabled={
          AuthCheck(abilities, AUTH_ACTIONS.RESTORE_ARCHIVE, authSubject)
            ? disabled
            : true
        }
      >
        <FontAwesomeIcon icon={["fas", "recycle"]} />
      </Button>
    </Tooltip>
  ) : (
    <Popconfirm
      title="Emin Misin?"
      onConfirm={onDelete}
      icon={
        <FontAwesomeIcon
          color="red"
          style={{ position: "absolute" }}
          icon={["far", "trash-alt"]}
        />
      }
      okText="Kaldır"
      cancelText="Geri"
    >
      <Tooltip title="Kaldır" placement="bottom">
        <Button
          disabled={
            AuthCheck(abilities, AUTH_ACTIONS.DELETE, authSubject)
              ? disabled
              : true
          }
          loading={loading}
          type="danger"
          icon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
          style={{
            marginRight: 8,
          }}
        />
      </Tooltip>
    </Popconfirm>
  );
}
